export default class ValidationError extends Error {
  constructor (errors) {
    super(`validation errors (${errors.length}`)
    this.validationErrors = errors
  }
}
